import React, {PropTypes as T} from 'react';

const Plus2Icon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Plus Icon"
    viewBox="0 0 13 13"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__plus2 ${className}`}>
    <path d="M5.359 13V7.606H0V5.353h5.359V0h2.283v5.353H13v2.253H7.642V13z" />
  </svg>
);

Plus2Icon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  Plus2Icon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_plus2.js